// removed by extract-text-webpack-plugin
module.exports = {"component":"_3I-lQ7C_VE0O4njmhV3k5o"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Messages/MessageThreadButton/MessageThreadButton.css
// module id = 1308
// module chunks = 0